export const MODAL_TYPES = {
  DETAILS: "details",
  LOCATION_CONTENT_EDITION: "locationContentEdition",
  LOCATION_PICKER: "locationPicker",
  MOVE: "move",
  ADD_BILLETS: "addBillets",
  SEARCH: "search",
  CLEAR_CONFIRM: "clearConfirm",
  CLEAR_LOCATION: "clearLocation",
  CRANE_SELECTION: "craneSelection",
  INFO_LOCATION: "infoLocation",
  NONE: "",
} as const;

export type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES];
